import React from 'react'
//import events from '../events'
import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
import MainStore from '../../../MainStore';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import moment from 'moment'
import './outlookStyle.css'

moment.locale('ru-RU')
const DragAndDropCalendar = withDragAndDrop(Calendar)
const localizer = momentLocalizer(moment);
const formats = {
    timeGutterFormat: (date, culture, localizer) => 
        localizer.format(date, 'HH:mm', culture),
    selectRangeFormat: (date, culture, localizer) =>
        localizer.format(date, 'HH:mm', culture)
    
};

export default class OutlookCalendar extends React.Component {
    constructor(props) {
        super(props);
        let minTime = new Date();
        minTime.setHours(7, 0, 0);
        let maxTime = new Date();
        maxTime.setHours(20, 0, 0);
        this.state = {
            events: [],
            displayDragItemInCell: true,
            minTime: minTime,
            maxTime: maxTime,
            user: (!!localStorage.getItem('schedulle_UserFilter') ? JSON.parse(localStorage.getItem('schedulle_UserFilter')) : null),
        }

        this.moveEvent = this.moveEvent.bind(this)
        this.newEvent = this.newEvent.bind(this)
        this.load = this.load.bind(this)
    }

    componentDidMount() {
        this.load();
    }

    load(dates, callback) {
        var scope = this;
        MainStore.setMaskVisible();
        var user = this.state.user;
        fetch('api/Schedulle?userId=' + (user ? user.id : (this.state.user ? this.state.user.id : '')) + '&start=' + (dates ? dates.start.toISOString() : (this.state.dates ? this.state.dates.start.toISOString() : '')), {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    if (callback) callback(result.works);
                    let events = [];

                    if (result.works) events = result.works.map(w => {
                        return {
                            id: w.id,
                            title: w.workNumber + " " + w.workCaption,
                            allDay: false,
                            start: new Date(w.start),
                            end: new Date(w.date)
                        }
                    });
                    scope.setState({ events: events });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDragStart = event => {
        this.setState({ draggedEvent: event })
    }

    dragFromOutsideItem = () => {
        return this.state.draggedEvent
    }

    onDropFromOutside = ({ start, end, allDay }) => {
        const { draggedEvent } = this.state

        const event = {
            id: draggedEvent.id,
            title: draggedEvent.title,
            start,
            end,
            allDay: allDay,
        }

        this.setState({ draggedEvent: null })
        this.moveEvent({ event, start, end })
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        const { events } = this.state

        let allDay = event.allDay

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const nextEvents = events.map(existingEvent => {
            return existingEvent.id == event.id
                ? { ...existingEvent, start, end }
                : existingEvent
        })

        this.setState({
            events: nextEvents,
        })

        // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
    }

    resizeEvent = ({ event, start, end }) => {
        const { events } = this.state

        const nextEvents = events.map(existingEvent => {
            return existingEvent.id == event.id
                ? { ...existingEvent, start, end }
                : existingEvent
        })

        this.setState({
            events: nextEvents,
        })

        //alert(`${event.title} was resized to ${start}-${end}`)
    }

    newEvent(event) {
        let newId = 0;
        if (this.state.events.length > 0) {
            let idList = this.state.events.map(a => a.id);
            newId = Math.max(...idList) + 1;
        }
        let hour = {
           id: newId,
           title: 'New Event',
           allDay: event.slots.length == 1,
           start: event.start,
           end: event.end,
         }
         this.setState({
           events: this.state.events.concat([hour]),
         })
    }



    render() {
        
        return (
            <>
                <h1>тестовый режим</h1>
                <DragAndDropCalendar
                    selectable
                    resizable
                    localizer={localizer}
                    formats={formats}
                events={this.state.events}
                onEventDrop={this.moveEvent}
                resizable
                onEventResize={this.resizeEvent}
                onSelectSlot={this.newEvent}
                onDragStart={console.log}
                    defaultView={Views.WORK_WEEK}
                    views={['day', 'agenda', 'work_week', 'month']}
                    defaultDate={new Date()}
                    min={this.state.minTime}
                    max={this.state.maxTime}
                popup={true}
                dragFromOutsideItem={
                    this.state.displayDragItemInCell ? this.dragFromOutsideItem : null
                }
                onDropFromOutside={this.onDropFromOutside}
                handleDragStart={this.handleDragStart}
                />
            </>
        )
    }
}

